<template>
  <v-dialog v-model="dialog" scrollable :lazy='true' width='85vw'>
    <div v-ripple :id="id" slot="activator" class="footer-btn text-xs-center caption" :data-ffid="data_ffid">{{buttonTitle}}</div>
    <v-card>
      <v-card-title fluid ma-0 pa-2>
        <v-layout row>
          <v-flex class="text-xs-left pa-2 pt-3 title font-weight-bold">
            {{title}}
          </v-flex>
          <v-flex class="pt-0 text-xs-right">
            <v-icon size="32px" @click="dialog = false" style="opacity:.5;" data-ffid="close-popup">close</v-icon>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text v-html="formattedContents" fluid style="height: 70vh; overflow-x:hidden; -webkit-overflow-scrolling: touch;" class="pt-0"/>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'

export default {
  name: 'TermsViewer',
  created () {
    // this allows a tags in the dialog to have access to the vue dialog object and close it
    window.mainvue.$on('closeDialog', () => (this.dialog = false))
  },
  mounted () {
    this.getContents()
  },
  props: {
    src: {},
    title: {},
    buttonTitle: {},
    id: {},
    data_ffid: {}
  },
  data () {
    return {
      dialog: false,
      formattedContents: ''
    }
  },
  methods: {
    async getContents () {
      let result = await axios.get(this.src)
      if (result.data) this.formattedContents = result.data
    }
  }
}
</script>
